import { PureAbility } from '@casl/ability'

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage'

export type Subjects = 'Auth' | 'Members' | 'Finance' | 'all' | 'MembersProfile' | 'Discount' | 'Games'

export enum Roles {
  admin = 'admin',
  author = 'author',
  support = 'support',
  player = 'player',
  kid = 'kid',
}

export type RolesType = `${Roles}` | Uppercase<`${Roles}`>

export interface Rule { action: Actions, subject: Subjects }

export const initialRules: Rule[] = [
  {
    action: 'read',
    subject: 'Auth',
  },
]

export const authorRules: Rule[] = [
  {
    action: 'read',
    subject: 'Members',
  },
]

export const adminRules: Rule[] = [
  {
    action: 'manage',
    subject: 'all',
  },
]

export const AppAbility = new PureAbility<[Actions, Subjects]>()
